import { isString } from 'lodash'
import { computed } from 'vue'
import { type RouteLocationRaw, type Router, useRoute, useRouter } from 'vue-router'

export default function useAppRouter() {
  const router: Router = useRouter()
  const currentRoute = useRoute()

  // Pages using Vue Router use `/` as page and `#/path/to/route` as hash (until mode is changed)
  const isLegacyPage = computed<boolean>(() => window.location.pathname !== '/')

  function getQueryParameter(name: string, defaultValue: string | null = null): string | null {
    const value = currentRoute.query?.[name]

    if (isString(value)) {
      return value
    }

    return defaultValue
  }

  function generateUrl(route: RouteLocationRaw): string {
    const { href } = router.resolve(route)

    // Support using router url from legacy pages
    // TODO: Return href directly once all pages are migrated
    const routePart = href.split('#')[1]

    return `/#${routePart}`
  }

  function redirectToRoute(route: RouteLocationRaw): void {
    // TODO: Remove legacy page support once all pages are migrated
    if (isLegacyPage.value) {
      window.location.href = generateUrl(route)
      return
    }

    router.push(route)
  }

  return {
    // Ref
    router,
    // Methods
    generateUrl,
    redirectToRoute,
    getQueryParameter,
  }
}
